import React from 'react';
import Hero from './Hero';
import Features from './Features';
import './Landing.css';

function Landing() {
  return (
    <div className="landing-container fade-in">
      <Hero />
      <Features />
    </div>
  );
}

export default Landing;